import { EmptyState, FlexBox } from '@dixa/lib-shared-habla';

export const InstrumentRendererError = (): JSX.Element => {
  return (
    <FlexBox flex="1" justifyContent="center" alignItems="center">
      <EmptyState
        title="Something went wrong"
        description="This data is currently unavailable due to an unexpected error. Our
        team has been notified and is looking into the issue."
        icon="exclamation"
        iconColor="red.500"
        buttonProps={{
          variant: 'primary',
          children: 'Try reloading',
          onClick: () => window.location.reload(),
        }}
      />
    </FlexBox>
  );
};
